import React from 'react';
import { ExternalReference } from 'graphql-query-contracts';
import { ViewExternalReference } from './ViewExternalReference';
import { Flex } from 'components';

type Props = {
  references: ExternalReference[];
};

export const ViewExternalReferences = ({ references }: Props) => {
  return (
    <Flex direction="column" gap={3}>
      {references.map(reference => {
        return (
          <ViewExternalReference key={reference.id} reference={reference} />
        );
      })}
    </Flex>
  );
};
